const darkModeSkin = {
  "dark-color-scheme": {
    "color-scheme": "dark",
  },
};

export default darkModeSkin;
